/* @flow */

import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';

import { REDUX_MSG_REQUEST_BO_STREAM_STOP } from '../../constants';
import getRequestDetails from './helpers/requestCommon';
import { BO_API_STOP_STREAM } from './types/common';

const sendStreamStopRequest: (distributorId: string, streamId: number, bookmark?: string, signal?: AbortSignal, keepAlive?: boolean) => RequestResponseMethodDefinitionType =
  (distributorId, streamId, bookmark, signal, keepAlive) =>
  (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<void> => {
    // Object 'requestDetails' contains 'headers', 'method' and 'uri' parameters
    const requestDetails = getRequestDetails(getState, distributorId, BO_API_STOP_STREAM);

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_BO_STREAM_STOP, {
      ...requestDetails,
      bookmark,
      keepAlive,
      signal,
      streamId,
    });
  };

export default sendStreamStopRequest;
